import { useEffect, useRef, useState } from "react";
import notifImg from "../../../../../picture/notification.png";
import Button from "../../../../Custom/Button/Button";

const allStatuses = [
  {
    status: "NIJE_ISTEKAO",
    color: "green"
  },
  {
    status: "USKORO_ISTICE",
    color: "orange"
  },
  {
    status: "ISTEKAO",
    color: "red"
  }
];

const SelectStatus = ({ selectedValue, onSelectChange, style }) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectRef = useRef(null);
  const optionsRef = useRef(null);

  const handleOpen = () => {
    setIsOpen(!isOpen);
  };
  const handleSelect = (value) => {
    const newValue = value === selectedValue ? "" : value;
    if (onSelectChange) onSelectChange(newValue);
    setIsOpen(false);
  };

  useEffect(() => {
    const rect = selectRef.current.getBoundingClientRect();
    optionsRef.current.style.width = rect.width + "px";

    function handleClickOutside(event) {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div ref={selectRef} style={style}>
      <div
        onClick={handleOpen}
        style={{ position: "relative", height: "100%" }}
      >
        <Button activation={true}>
          <img src={notifImg} style={{ width: "30px" }} />
        </Button>
      </div>
      <div
        ref={optionsRef}
        style={{
          position: "fixed",
          zIndex: "10",
          display: isOpen ? "block" : "none",
          boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.15)",
          maxHeight: "300px",
          overflowY: "auto",
          width: "100%",
          ...style
        }}
      >
        {allStatuses.map((value, index) => (
          <div
            key={index}
            onClick={() => handleSelect(value.status)}
            style={{
              padding: "5px",
              borderBottom: "1px solid black",
              cursor: "pointer",
              backgroundColor:
                value.status == selectedValue ? "lightgrey" : "white",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <div
              style={{
                width: "25px",
                height: "25px",
                backgroundColor: value.color
              }}
            ></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SelectStatus;
